import React, { Fragment } from "react";

import {
  Button,
  Divider,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Grid,
  makeStyles,
  Typography,
  CardHeader,
  Menu,
  MenuItem,
  Fab,
  Hidden,
  Tooltip,
} from "@material-ui/core";
import { MoreVert } from "@material-ui/icons";
import { Add } from "@material-ui/icons";
import { notifUtils } from "../../components/NotifUtils/NotifUtils";
import Skeleton from "@material-ui/lab/Skeleton";

import moment from "moment";
import BaseLayout from "../../components/BaseLayout/BaseLayout";
import { submitFormPromoMall } from "./Container/FormPromoMall";
import editorialStore from "../../Store/EditorialStore";
import InputSearch from "../../components/InputSearch/InputSearch";
import { AntTab, AntTabs } from "../../components/TabPanel/TabPanel";
import EditorialService from "../../Services/EditorialService/EditorialService";

import { confirm } from "../../components/ConfirmationDialog/ConfirmationDialog";
import parse from "html-react-parser";

const useStyles = makeStyles((theme) => ({
  icon: {
    marginRight: theme.spacing(2),
  },
  heroContent: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(8, 0, 6),
  },
  heroButtons: {
    marginTop: theme.spacing(4),
  },
  cardGrid: {
    paddingTop: theme.spacing(8),
    paddingBottom: theme.spacing(8),
  },
  card: {
    // height: '100%',
    display: "flex",
    flexDirection: "column",
    width: "270px",
    margin: "10px",
  },
  cardMedia: {
    paddingTop: "56.25%", // 16:9
  },
  cardContent: {
    flexGrow: 1,
  },
  footer: {
    backgroundColor: theme.palette.background.paper,
    padding: theme.spacing(6),
  },
  paper: {
    padding: theme.spacing(0.5),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  description: {
    fontSize: "12px",
    color: theme.palette.text.secondary,
  },
  colorStart: {
    color: "#4CAF50",
  },
  colorEnd: {
    color: "#F44336",
  },

  // appBar

  demo1: {
    backgroundColor: theme.palette.background.paper,
    marginBottom: 10,
  },
  fab: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));

function ListPromoMall(props) {
  const classes = useStyles();
  const { dataMall, dataTab, dataList } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const [promotionState, promotionActions] = editorialStore();
  console.log(dataMall);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const setStatusRemove = () => {
    console.log(dataMall.id);
    confirm(
      `${!dataTab.deleted ? "Remove Item" : "Restore Item"}`,
      `Are you sure to ${!dataTab.deleted ? "remove" : "restore"} this item ?`
    ).then(async (onProcess) => {
      if (!dataTab.deleted) {
        // await promotionActions.deletedMall(dataMall.id);
        await EditorialService.deleteData(dataMall.id);
        notifUtils("Successfully Remove Editorial", "success");
      } else {
        const params = [
          {
            op: "replace",
            path: "/deleted ",
            value: false,
          },
        ];
        let notif = `Successfully Restore Promotion`;
        await EditorialService.patchData(dataMall.id, params, notif);
      }
      dataList(true);
    });
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Card className={classes.card}>
      <CardMedia
        className={classes.cardMedia}
        image={dataMall.image_urls[0]}
        title="Image title"
      />
      <CardContent className={classes.cardContent}>
        <Grid container spacing={2}>
          <Grid item xs={10}>
            <Typography gutterBottom variant="h5" component="h2">
              {dataMall.title}
            </Typography>
          </Grid>
          <Grid item xs={10}>
            <Typography gutterBottom variant="h6" component="h4">
              {dataMall.sub_title}
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <CardHeader
              action={
                <Fragment>
                  <MoreVert onClick={handleClick} />

                  <Menu
                    id="long-menu"
                    elevation={0}
                    anchorEl={anchorEl}
                    getContentAnchorEl={null}
                    keepMounted
                    open={open}
                    onClose={handleClose}
                  >
                    {/* {permissionEditCategoryProduct && */}
                    <MenuItem onClick={() => props.doEdit(dataMall)}>
                      Edit
                    </MenuItem>

                    {!dataTab.deleted && (
                      <Button onClick={setStatusRemove} color="primary">
                        Remove
                      </Button>
                    )}
                    {dataTab.deleted && (
                      <Button onClick={setStatusRemove} color="primary">
                        Restore
                      </Button>
                    )}
                  </Menu>
                </Fragment>
              }
            ></CardHeader>
          </Grid>
        </Grid>
        <Typography className={classes.description}>
          {parse(dataMall.description || "")}
        </Typography>
      </CardContent>
      <Divider />
      <CardActions>
        <Grid container spacing={2} className={classes.paper}>
          <Grid item xs={6}>
            <div>
              <Button size="small" className={classes.colorStart}>
                START
              </Button>
            </div>
            <Typography variant="caption" display="block" gutterBottom>
              {moment(dataMall.start_time).format("DD/MM/YYYY") || "-"}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <div>
              <Button size="small" className={classes.colorEnd}>
                END
              </Button>
            </div>
            <Typography variant="caption" display="block" gutterBottom>
              {moment(dataMall.end_time).format("DD/MM/YYYY") || "-"}
            </Typography>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
}

function PromoMall(props) {
  const classes = useStyles();
  const [componentWillmount, setComponentWillMount] = React.useState(false);
  const [search, setSearch] = React.useState("");
  const [promotionState, promotionActions] = editorialStore();
  const [expanded, setExpanded] = React.useState(false);

  // anttabs
  const [tab] = React.useState(0);
  const [tabActive, setTabActive] = React.useState(0);
  const prevTabActive = usePreviousTab(tabActive);

  let arrPromotionList = [
    { label: "Active", deleted: false },
    { label: "Inactive", deleted: false },
    { label: "Removed", deleted: true },
    { label: "Highlight" },
  ];

  let perPage = 8;
  const handleTabChange = (event, newTab) => {
    setExpanded(false);
    setTabActive(newTab);
  };

  function usePreviousTab(value) {
    const ref = React.useRef();
    React.useEffect(() => {
      ref.current = value;
    });
    return ref.current;
  }

  const handleGetPromotionMallList = (refresh) => {
    // if()
    console.log(arrPromotionList[tabActive]);
    console.log("-------------------");
    if (arrPromotionList[tabActive].label === "Highlight") {
      console.log("lontong");
      var query = {
        num: perPage.toString(),
        cursor:
          refresh === false && tabActive === prevTabActive
            ? promotionState.header["x-cursor"]
            : "",
        position: "",

        // deleted:
        //   arrPromotionList[tabActive].deleted === true ? "true" : "false",
        current_date: moment().format("YYYY-MM-DD"),
        keyword: search,
        type: "property",
        is_landing: 1,
      };
      promotionActions.getMall(
        query,
        refresh
        // refresh === false && tabActive === prevTabActive ? true : false
      );
    } else {
      var query = {
        num: perPage.toString(),
        cursor:
          refresh === false && tabActive === prevTabActive
            ? promotionState.header["x-cursor"]
            : "",
        position: "",
        deleted:
          arrPromotionList[tabActive].deleted === true ? "true" : "false",
        keyword: search,
        current_date:
          arrPromotionList[tabActive].label === "Active" ||
          arrPromotionList[tabActive].label === "Inactive"
            ? moment().format("YYYY-MM-DD")
            : "",
        is_active:
          arrPromotionList[tabActive].label === "Active"
            ? 1
            : arrPromotionList[tabActive].label === "Inactive"
            ? 0
            : "",
        type: "property",
      };
      promotionActions.getMall(
        query,
        refresh
        // refresh === false && tabActive === prevTabActive ? true : false
      );
    }
  };

  const handleActions = (value) => {
    if (value) {
      submitFormPromoMall("Update Promotion Mall", value).then(
        (onProcess) => {},
        (onCancel) => {
          // setComponentWillMount(!componentWillmount);
          handleGetPromotionMallList(true);
        }
      );
    } else {
      submitFormPromoMall("Create Promotion Mall", null).then(
        (onProcess) => {},
        (onCancel) => {
          // setComponentWillMount(!componentWillmount);
          handleGetPromotionMallList(true);
        }
      );
    }
  };

  React.useEffect(() => {
    // Add delay in search
    const timeout = setTimeout(() => {
      handleGetPromotionMallList(true);
    }, 500);

    return () => clearTimeout(timeout);
  }, [componentWillmount, promotionActions, search, tabActive]);

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  return (
    <BaseLayout>
      <Fragment>
        {/* list promotion mall */}
        <Grid container style={{ padding: 5, marginBottom: 10 }}>
          <Grid
            container
            item
            xs={10}
            direction="row"
            alignItems="flex-end"
            justify="flex-start"
          >
            <h1>EDITORIAL</h1>
          </Grid>
        </Grid>
        {/* list promotion mall end */}

        <Grid container style={{ padding: 5, marginBottom: 10 }}>
          <Grid
            container
            item
            xs={10}
            direction="row"
            alignItems="flex-end"
            justify="flex-start"
          >
            <InputSearch
              value={search}
              onChange={(e) => {
                handleSearch(e);
              }}
              placeholder="Search"
            />
          </Grid>
          <Grid container item xs={2} justify="flex-end" alignItems="flex-end">
            <Hidden xsDown implementation="css">
              {props.params.create && (
                <Tooltip
                  title="add users"
                  aria-label="add"
                  arrow
                  placement="bottom"
                >
                  <Fab
                    onClick={() => handleActions(null)}
                    color="secondary"
                    variant="extended"
                    aria-label="add"
                    style={{
                      marginRight: "10px",
                      borderRadius: 0,
                      padding: "0 30px",
                    }}
                  >
                    <Add /> Add{" "}
                  </Fab>
                </Tooltip>
              )}
            </Hidden>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <div className={classes.demo1}>
            <Grid container>
              <Grid
                container
                item
                xs
                direction="row"
                alignItems="flex-end"
                justify="flex-start"
              >
                <AntTabs
                  style={{ marginTop: "10px" }}
                  value={tabActive !== "" ? tabActive : 0}
                  onChange={handleTabChange}
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  {arrPromotionList.map((promotionList, keyPromotionList) => {
                    return (
                      <AntTab
                        key={keyPromotionList}
                        label={promotionList.label}
                      />
                    );
                  })}
                </AntTabs>
              </Grid>
            </Grid>
          </div>

          <Grid item xs={12} container justify="center">
            {(promotionState.isLoading
              ? Array.from(new Array(10))
              : promotionState.data
            ).map((value, key) => {
              return (
                <Fragment key={key}>
                  {value ? (
                    <ListPromoMall
                      key={key}
                      dataMall={value}
                      dataTab={arrPromotionList[tabActive]}
                      dataList={handleGetPromotionMallList}
                      // permissionEditCategoryProduct={props.params.update}
                      // doEdit={() => {
                      //     handleActions(value);
                      // }}

                      doEdit={() => handleActions(value)}

                      // permissionDeleteCategoryProduct={props.params.delete}
                      // doDelete={() => {
                      //     handleDelete(value);
                      // }}
                    />
                  ) : (
                    <Card className={classes.card}>
                      <CardHeader
                        avatar={
                          <Skeleton
                            variant="circle"
                            width="40px"
                            height="40px"
                          />
                        }
                        title={<Skeleton width="20%" height="10px" />}
                        subheader={<Skeleton width="5%" height="10px" />}
                      />
                    </Card>
                  )}
                </Fragment>
              );
            })}
          </Grid>

          {!promotionState.isLoading && promotionState.data.length === 0 && (
            <Grid item xs={12}>
              <div className={classes.demo1}>
                <Grid
                  item
                  xs
                  container
                  justify="center"
                  style={{ margin: 10, padding: 12 }}
                >
                  <span>No Data</span>
                </Grid>
              </div>
            </Grid>
          )}

          {promotionState.data.length >= perPage - 1 && (
            <Grid
              container
              direction="row"
              justify="center"
              alignItems="center"
              style={{ padding: "10px" }}
            >
              {promotionState.lastPage ? (
                <h2>~</h2>
              ) : (
                <Button
                  onClick={() => handleGetPromotionMallList(false)}
                  size="small"
                  color="secondary"
                  variant="contained"
                  disabled={promotionState.isLoading}
                >
                  {promotionState.isLoading ? "Please Wait" : "Load More"}
                </Button>
              )}
            </Grid>
          )}
          <Hidden smUp implementation="css">
            {props.params.create && (
              <Tooltip
                title="add reservation"
                aria-label="add"
                arrow
                placement="left"
              >
                <Fab
                  aria-label="Add"
                  classes={{ root: "FabMobile" }}
                  className={classes.fab}
                  color="primary"
                  onClick={() => handleActions(null)}
                >
                  <Add />
                </Fab>
              </Tooltip>
            )}
          </Hidden>
        </Grid>
      </Fragment>
    </BaseLayout>
  );
}

export default PromoMall;
